module.exports = __webpack_public_path__ + "static/img/code.19949b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/code.png
// module id = 7n1Q
// module chunks = 171